// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-toolbar,
.toolbar-container {
  height: 42px;
}

ion-button {
  width: 60px;
  height: 42px;
  font-size: 14px;
  transform: translateY(-8px);
  --background-hover-opacity: 0;
}

ion-title {
  text-align: center;
  transform: translateY(-8px);
}

ion-content {
  text-align: center;
}

.ios-button-styling {
  padding-top: 0%;
}

.mobile-popup {
  display: flex;
  flex-direction: column;
  padding: 5px 25px 25px 25px;
}
@media (orientation: portrait) and (min-width: 768px) {
  .mobile-popup {
    max-width: 50%;
  }
}
@media (orientation: landscape) and (min-width: 1024px) {
  .mobile-popup {
    max-width: 50%;
  }
}
.mobile-popup .close-button {
  background-color: white;
  align-self: flex-end;
}
.mobile-popup .title {
  display: flex;
  align-self: center;
  font-size: x-large;
  font-weight: bold;
  transform: translateY(-33px);
}
.mobile-popup .content {
  margin-top: 10px;
  text-align: center;
  align-self: center;
}`, "",{"version":3,"sources":["webpack://./src/app/popovers/popover-content/popover-content.component.scss"],"names":[],"mappings":"AAAA;;EAEE,YAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,2BAAA;EACA,6BAAA;AACF;;AAEA;EACE,kBAAA;EACA,2BAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AACA;EACE,eAAA;AAEF;;AACA;EACE,aAAA;EACA,sBAAA;EACA,2BAAA;AAEF;AADE;EAJF;IAKI,cAAA;EAIF;AACF;AAHE;EAPF;IAQI,cAAA;EAMF;AACF;AALE;EACE,uBAAA;EACA,oBAAA;AAOJ;AALE;EACE,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;EACA,4BAAA;AAOJ;AALE;EACE,gBAAA;EACA,kBAAA;EACA,kBAAA;AAOJ","sourcesContent":["ion-toolbar,\r\n.toolbar-container {\r\n  height: 42px;\r\n}\r\n\r\nion-button {\r\n  width: 60px;\r\n  height: 42px;\r\n  font-size: 14px;\r\n  transform: translateY(-8px);\r\n  --background-hover-opacity: 0;\r\n}\r\n\r\nion-title {\r\n  text-align: center;\r\n  transform: translateY(-8px);\r\n}\r\n\r\nion-content{\r\n  text-align: center;\r\n}\r\n.ios-button-styling {\r\n  padding-top: 0%;\r\n}\r\n\r\n.mobile-popup {\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding: 5px 25px 25px 25px;\r\n  @media (orientation: portrait) and (min-width: 768px) {\r\n    max-width: 50%;\r\n  }\r\n  @media (orientation: landscape) and (min-width: 1024px) {\r\n    max-width: 50%;\r\n  }\r\n  .close-button {\r\n    background-color: white;\r\n    align-self: flex-end;\r\n  }\r\n  .title {\r\n    display: flex;\r\n    align-self: center;\r\n    font-size: x-large;\r\n    font-weight: bold;\r\n    transform: translateY(-33px);\r\n  }\r\n  .content {\r\n    margin-top: 10px;\r\n    text-align: center;\r\n    align-self: center;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
